import { render } from "./GoodsKind.vue?vue&type=template&id=7aad752b&scoped=true"
import script from "./GoodsKind.vue?vue&type=script&lang=js"
export * from "./GoodsKind.vue?vue&type=script&lang=js"

import "./GoodsKind.vue?vue&type=style&index=0&id=7aad752b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aad752b"]])

export default __exports__